import { Link } from 'react-router-dom';
import { mangaCategories } from '@/mocks/manga';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-heading font-bold text-foreground-100 mb-4">H漫画</h3>
            <p className="text-sm text-foreground-400 leading-relaxed">
              H漫画 - 最新H漫画在线阅读平台，收录海量优质H漫画资源，支持在线阅读与下载，每日更新最新H漫画内容，涵盖多种风格与题材。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">首页</Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">分类浏览</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">热门分类</h4>
            <ul className="space-y-2">
              {mangaCategories.slice(1, 7).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">联系我们</h4>
            <ul className="space-y-2 text-sm text-foreground-400">
              <li>邮箱：contact@hmanga.com</li>
              <li>客服QQ：1234567890</li>
              <li>工作时间：9:00 - 21:00</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 H漫画 版权所有 | 本站内容仅供成年人阅读 | 18岁以下请勿浏览
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-500">安全浏览</span>
            <span className="text-xs text-foreground-500">隐私保护</span>
            <span className="text-xs text-foreground-500">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}